import { createContext } from "react";
import { AppCtx } from "./types";

export const AppContext = createContext({} as AppCtx);
